var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"socket",class:_vm._f("kebab")([_vm.type, _vm.socket.name]),attrs:{"title":_vm.socket.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }